import { Text } from '~components/Typography';
import { useAccountContext } from '~context/account';
import { annals } from '~features/annals/hooks';
import { useModal } from '~hooks/useModal';
import { useSession } from '~hooks/useSession';
import { ToggleSwitch } from '~shared/ui/atoms';

import { useBotModels } from '../../model/useBotModels';
import { BotModelsExplorerModal } from '../BotModelsExplorerModal';
import { BotModelInfoContainer } from './styles';

type Props = {
	recipientId: string;
};

export const BotModelInfo = ({ recipientId }: Props) => {
	const { isOpen, open, close } = useModal();
	const { isDemoUser } = useSession();

	const { activeModelTitle } = useBotModels();
	const { hasSubscription } = useAccountContext();

	const annalsChangeBotModelOpenDialog = annals.bot.useChangeBotModelChatInput({
		botId: recipientId,
		currentModel: activeModelTitle || '',
	});

	const handleOpen = () => {
		open()();
		annalsChangeBotModelOpenDialog();
	};

	return !isDemoUser && activeModelTitle ? (
		<>
			<BotModelInfoContainer role="button" onClick={handleOpen}>
				{hasSubscription ? (
					<Text size="S">
						You&apos;re using <span>{activeModelTitle}</span>: manage AI{' '}
						<span>models</span>.
					</Text>
				) : (
					<>
						<Text size="S">
							You&apos;re using <span>{activeModelTitle}</span>
						</Text>
						<ToggleSwitch
							checked={false}
							height={16}
							thumbSize={10}
							width={26}
							borderColor="var(--color-white-solid)"
						/>
						<Text size="S">Get a Premium model</Text>
					</>
				)}
			</BotModelInfoContainer>

			<BotModelsExplorerModal
				recipientId={recipientId}
				open={isOpen}
				locked={false}
				onClose={close}
			/>
		</>
	) : null;
};
